import { SxProps, Theme } from '@mui/material/styles';

import { colors } from '../UI/colors';

export const exploreCarouselStyles = {
  container: {
    borderRadius: '24px',
    padding: '16px 20px',
    backgroundColor: 'common.white',
  } as SxProps<Theme>,

  header: {
    fontFamily: '"Work Sans", sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '-0.5px',
    marginBottom: '8px',
    color: 'neutral1.dark',
  } as SxProps<Theme>,

  slidesContainer: {
    display: 'flex',
    gap: '8px',
  },

  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
    maxWidth: '345px',
  } as SxProps<Theme>,

  arrow: {
    width: '44px',
    height: '44px',
    padding: 0,
    color: colors.dark,
    border: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  } as SxProps<Theme>,

  arrowDisabled: {
    width: '44px',
    height: '44px',
    padding: 0,
    color: colors.borderGray,
    border: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  } as SxProps<Theme>,

  dots: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
  } as SxProps<Theme>,

  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '10px',
    backgroundColor: '#DADADA',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#848484',
    },
  } as SxProps<Theme>,

  dotActive: {
    width: '33px',
    backgroundColor: colors.dark,
    '&:hover': {
      backgroundColor: colors.dark,
    },
  } as SxProps<Theme>,
};